export const visit = (vm, at) => {
vm(require("./availability/nl.lyaml"));
vm(require("./typical-response-time/nl.lyaml"));
vm(require("./default/nl.lyaml"));
at({ "nl": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "ok\xE9" } } });
};